import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core'

import { TranslatePipe } from '@ngx-translate/core'

export type ArticlePurchaseFlowStep =
  'account' | 'verify' | 'checkout' | 'continueEmail' | 'success'

type ArticlePurchaseFlowState = 'completed' | 'active' | 'upcoming'

const DEFAULT_STEP_ORDER: ArticlePurchaseFlowStep[] = [
  'account',
  'verify',
  'checkout',
  'success',
]

const DEFAULT_STEP_ORDER_WITHOUT_VERIFY: ArticlePurchaseFlowStep[] = [
  'account',
  'checkout',
  'success',
]

const STUDENT_EMAIL_STEP_ORDER: ArticlePurchaseFlowStep[] = [
  'account',
  'verify',
  'checkout',
  'continueEmail',
  'success',
]

const STUDENT_EMAIL_STEP_ORDER_WITHOUT_VERIFY: ArticlePurchaseFlowStep[] = [
  'account',
  'checkout',
  'continueEmail',
  'success',
]

@Component({
  selector: 'dhp-article-purchase-flow-context',
  templateUrl: './article-purchase-flow-context.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe],
})
export class ArticlePurchaseFlowContextComponent {
  readonly currentStep = input.required<ArticlePurchaseFlowStep>()
  readonly includeStudentEmailStep = input(false)
  readonly includeVerificationStep = input(true)

  readonly stepOrder = computed(() =>
    this.includeStudentEmailStep()
      ? this.includeVerificationStep()
        ? STUDENT_EMAIL_STEP_ORDER
        : STUDENT_EMAIL_STEP_ORDER_WITHOUT_VERIFY
      : this.includeVerificationStep()
        ? DEFAULT_STEP_ORDER
        : DEFAULT_STEP_ORDER_WITHOUT_VERIFY
  )

  readonly activeStepNumber = computed(
    () => this.stepOrder().indexOf(this.currentStep()) + 1
  )

  readonly steps = computed(() => {
    const activeIndex = this.activeStepNumber() - 1

    return this.stepOrder().map((step, index) => {
      const state: ArticlePurchaseFlowState =
        index < activeIndex
          ? 'completed'
          : index === activeIndex
            ? 'active'
            : 'upcoming'

      return {
        key: `pages.articlePurchase.flow.steps.${step}`,
        number: index + 1,
        statusKey: `pages.articlePurchase.flow.status.${state}`,
        isActive: state === 'active',
        isCompleted: state === 'completed',
        isUpcoming: state === 'upcoming',
      }
    })
  })
}
